import React, { ReactNode, useMemo } from "react"
import {
  ToggleButtonGroup,
  ToggleButtonGroupProps,
  ToggleButtonProps,
  useTheme,
} from "@mui/material"
import { deepmerge } from "@mui/utils"

import { useTranslation } from "providers/i18n"

import { IFeature } from "interfaces"
import { getFeatureName } from "utils/feature"
import { getIcon } from "utils/icon"

import { CategoryFilterButton } from "./CategoryFilterButton"
import { ShopIcon, CustomIcon } from "components/icons"

interface ICategoryFilterButtonProps extends ToggleButtonProps {
  Icon?: ReactNode
}

interface ICategoryFilterBarProps extends ToggleButtonGroupProps {
  activeCategory?: string
  categories?: IFeature[]
  renderFilterButton?: React.FunctionComponent<ICategoryFilterButtonProps>
}

export const CategoryFilterBar: React.FC<ICategoryFilterBarProps> = ({
  activeCategory,
  categories = [],
  onChange = () => {},
  sx = {},
  renderFilterButton: RenderFilterButton = CategoryFilterButton,
  ...props
}) => {
  const { t } = useTranslation()

  const theme = useTheme()
  const allIcon = useMemo(
    //@ts-ignore
    () => getIcon(theme?.assets?.categoryFilter?.all) || <ShopIcon />,
    [theme]
  )
  const { styleOverrides = {} } =
    theme.components?.[`AppCategoryFilterBar`] || {}
  const { root, filterButton } = styleOverrides

  return (
    <ToggleButtonGroup
      value={activeCategory}
      onChange={onChange}
      exclusive
      // TODO:: Explore a solution to incorporate custom variants into the theme (TypeScript version).
      // @ts-ignore
      variant="borderSeperate"
      sx={deepmerge(root, sx)}
      {...props}
    >
      <RenderFilterButton
        onClick={onChange}
        value={"ALL"}
        key={`category-filter-all`}
        Icon={allIcon}
        sx={filterButton}
      >
        {t("All Categories")}
      </RenderFilterButton>
      {categories.map((category) => (
        <RenderFilterButton
          value={category.id}
          key={`category-filter-${category.id}`}
          Icon={<CustomIcon path={category.properties?.icon_path} />}
        >
          {t(getFeatureName(category))}
        </RenderFilterButton>
      ))}
    </ToggleButtonGroup>
  )
}
